import { m } from 'framer-motion';
import { SectionHeading } from './SectionHeading';

function calculateYearsOfExperience() {
  const startDate = new Date(2014, 10, 1);
  const today = new Date();
  const years = today.getFullYear() - startDate.getFullYear();
  const months = today.getMonth() - startDate.getMonth();
  return months < 0 ? years - 1 : years;
}

export function About({ isDark = true }) {
  const yearsOfExperience = calculateYearsOfExperience();

  return (
    <m.section
      id="about"
      className="mb-20 sm:mb-24"
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
      viewport={{ once: true, margin: '-100px' }}
    >
      <SectionHeading index="01" title="about" isDark={isDark} />

      <m.p
        className={`u-prose text-[1.0625rem] leading-[1.75] transition-colors ${
          isDark ? 'text-neutral-400' : 'text-neutral-600'
        }`}
        initial={{ opacity: 0, y: 10 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.45, delay: 0.15 }}
        viewport={{ once: true }}
      >
        Franco is a Software Developer from Buenos Aires, Argentina, specializing in
        creating digital experiences. With over{' '}
        <span className={`u-num ${isDark ? 'text-neutral-200' : 'text-neutral-900'}`}>
          {yearsOfExperience}
        </span>{' '}
        years of experience, he has had the privilege of working with industry leaders
        like{' '}
        {/* Emphasis inside prose comes from weight and value, never from a
            family swap — a second sans mid-sentence just reads as a mistake. */}
        <strong className={`font-medium ${isDark ? 'text-neutral-300' : 'text-neutral-800'}`}>
          Deloitte
        </strong>{' '}
        and{' '}
        <strong className={`font-medium ${isDark ? 'text-neutral-300' : 'text-neutral-800'}`}>
          Mercado Libre
        </strong>
        , as well as innovative startups across Latin America.
      </m.p>
    </m.section>
  );
}
